import React from 'react'

module.exports = {
    color_black: '曜石黑',
    color_orange: '爱马仕橙',
    color_blue: '科技蓝',
    pay_now: '立即支付',
    check_order: '查看订单',
    notifi_tryagain: '<i class="i-oc-queue"></i><h3>正在为您排队中...</h3><p>当前抢购人数较多，正在努力为您加载，请稍后重试喔。</p>',
    notifi_yongdu: `<i class="i-oc-yongdu"></i><h3>抱歉，网络走丢了</h3><p>当前抢购人数较多，正在努力为您加载，请稍后重试喔。</p>`,
    notifi_success: '<i class="i-oc-chenggong"></i><h3>恭喜，您已经成功抢到玩客云1台</h3><p>支付有效期为45分钟，请尽快完成支付，否则订单将失效喔。</p>',
    notifi_chakan: '<i class="i-oc-chakan"></i><h3>每位玩客只能购买1台玩客云</h3><p>你已经成功抢购，不要贪心哦。</p>',
    notifi_limit1: '<h3>请您先预约</h3><p>预约成功的用户才能参与抢购玩客云哦！</p>',

    login_remind: '为了方便购买，请提前登录',
    login_now: '立即登录',
    close: '关闭',
    ok: '确定',
    pic_soldout: '已抢完',
    more: '了解更多',
    count_down1: '离抢购开始还有',
    count_down2: '正在抢购中...',
    buy_now: '立即下单',
    price_official: <span className="oc-buy-price-pay">官方指导价: 599元</span>,
    price_official_v2: <div className="np-buy-price">官方指导价：<em><span>599</span>元</em></div>,
    price_yuan: '元',
    price_total: <h3>合计：<strong>599</strong>元</h3>,
    price_total_custom: props => <h3>合计：<strong>{props.price}</strong>元</h3>,
    price_presell: <h3>预售价：<strong>499</strong>元</ h3>,
    price_discount: props => <span className="oc-buy-price-pay">活动优惠价: {props.price}元 <s>599元</s></span>,
    tips_deliver: '温馨提示：请预约后及时抢购,购买成功后3天内发货 | 支持7天无理由退货',
    tips_presell_deliver: '* 预售商品发货时间将在您选定发货时间内，按付款先后顺序发出，网心保留提前发货的权利。',
    goods_tip: <div className="np-buy-promise">
                    <ul className="oc-promise">
                        <li><img src="/images/purchase/ico_cart_7.png" alt="" />7天无理由退换货</li>
                        <li><img src="/images/purchase/ico_cart_15.png" alt="" />15天质量问题换货</li>
                        <li><img src="/images/purchase/ico_cart_365.png" alt="" />365天保修</li>
                    </ul>
                </div>,
    submit_order: '提交订单',

    banner_title: '玩客云 畅快下载的私人云盘',
    mj_price_title: <div className="np-buy-text">
                        <h2>玩客云 畅快下载的私人云盘</h2>
                        {/* <p>全新一代共享智能硬件，用户分享闲置的网络带宽、存储空间以及计算资源；</p>
                        <div className="np-buy-price">官方价：<em><span>599</span>元</em></div> */}
                        <p>【满599立减271元，到手价328元！限时活动】全新一代共享智能硬件，用户分享闲置的网络带宽、存储空间以及计算资源；</p>
                        <div className="np-buy-price">限时优惠：<em><span>328</span>元</em><del>599元</del></div>
                    </div>,
    mj_price: <div className="np-buy-sum">
                <p>合计：<em>480</em>元</p>
             </div>,
    // sub_title: <p><strong><a href="/html/book.html">【119元优惠券，满599元使用，立即领取】</a></strong>全新一代区块链共享经济智能硬件，全球首个共享计算+区块链应用</p>,
    sub_title: <p>全新一代区块链共享经济智能硬件，全球首个共享计算+区块链应用</p>,
    banner_subtitle: '2小时不限量火热预定中',
    presell_ing: '不限量预售开启中',
    deposit_number1: '已有',
    deposit_number2: '人预约',
    date_day: '天',
    date_hour: '时',
    date_minute: '分',
    date_second: '秒',

    colorcom_subtitle: '选择颜色',
    colorcom_zero:'(售罄)',
    delivercom_subtitle: '选择发货日期',

    imagecode_title: '验证码',
    imagecode_input: '请输入图形验证码',

    rtncode_30004: '当前时间不能抢购',
    rtncode_30006:  '状态异常',
    rtncode_30007 : '已经抢购成功',
    rtncode_30008: '找不到订单记录',
    rtncode_30009: "没有抢购到资格，无法支付",
    rtncode_30003: '已经预定过了',
    rtncode_40000: "非活动时间",
    rtncode_30106: '宝码已经使用',
    rtncode__2: '系统繁忙，请稍后再试',
    rtncode__2004: '本期已经售罄',
    rtncode__2000: '抢购未开始',
    rtncode__1003: '宝码已被使用',
    rtncode__5: '超过频率限制，请稍后再试',
    rtncode_41006: '订单已超时，请规定时间内付款',
    rtncode_41007: '<h3>您的订单提交失败</h3><p>您在预售订单生成后实际付款前有超过2次超时未支付订单，已失去继续参与本次预售活动的资格，感谢您的支持。</p>',
    rtncode_41007_2: '购买次数超过限制',
    rtncode_41009: '已支付',
    rtncode_41013: '没有这个发货日期了',
    rtncode_41014: '系统繁忙，请稍后再次刷新',
    rtncode_41016: '订单不存在',
    rtncode_41008: '<h3>每位用户限购1台玩客云</h3><p>为充分保证广大玩客的利益，已成功在官网购买过的用户，将不再参与本次玩客云预售，请您谅解。</p>',
    rtncode__301: '<h3>当前账号异常</h3><p>系统检测到您当前账号存在异常行为记录，您将无法参与本次购买，请您谅解。</p>',
    rtncode_30032: '<h3>当前账号异常</h3><p>系统检测到您当前账号存在异常行为记录，您将无法参与本次购买，请您谅解。</p>',
    rtncode_41011: '<h3>您的订单提交失败</h3><p>您在预售订单生成后实际付款前有超过2次超时未支付订单，已失去继续参与本次预售活动的资格，感谢您的支持。</p>',
    rtncode__1: '参数不合法',
    rtncode_41010: '<h3>您有1笔未支付订单</h3>'+'<p>检测到您存在一笔未支付预售订单，请您尽快完成付款。如果超时未支付，本次订单将自动失效。</p>',
    rtncode_30005: '<i class="i-oc-sorry"></i><h3>抱歉，本轮玩客云已售罄</h3><p>在您选购颜色时，我们的玩客云已经售罄，请不要灰心，悄悄的告诉您，您可免预约直接参与下期抢购喔。</p>',
    rtncode_30016: '<i class="i-oc-sorry"></i><h3>抱歉，曜石黑已售罄</h3><p>都是我不好，人数太多，机器太少，曜石黑已售罄，建议您尝试选择其他颜色喔。</p>',
    rtncode_30025: '<i class="i-oc-sorry"></i><h3>抱歉，爱马仕橙已售罄</h3><p>都是我不好，人数太多，机器太少，爱马仕橙已售罄，建议您尝试选择其他颜色喔。</p>',
    rtncode_30026: '<i class="i-oc-sorry"></i><h3>抱歉，科技蓝已售罄</h3><p>都是我不好，人数太多，机器太少，科技蓝已售罄，建议您尝试选择其他颜色喔。</p>',
    tips_continue: '继续购买',
    rtncode_41012: '<i class="i-oc-finished"></i><p>活动尚未开始，请您耐心等待喔</p>',
    rtncode_41018: '<i class="i-oc-finished"></i><p>玩客云预售尚未开启，请您耐心等待喔。</p>',
    rtncode_41022: '<i class="i-oc-finished"></i><p>活动尚未开启，请您耐心等待喔。</p> ',
    rtncode_30303: '<i class="i-oc-finished"></i><p>满减活动已结束</p>',

    rtntqcode_used: '特权码已经使用',

    rtntqcode_used: '特权码已经使用',

    fcode_notget: '未检测到宝码，去使用宝码',
    fcode_use: '使用宝码购买',
    fcode_tips: '支持：7天无理由退货，15天包换，1年保修',

    tqcode_notget: '未检测到特权码，去使用特权码',
    tqcode_use: '使用特权码购买',

    deposit_notbegin: '<i class="i-oc-finished"></i><h3>活动尚未开启</h3><p>预售开启时间：12月13日-19日 每天10:00-18:00，敬请期待</p>',
    deposit_end: '<i class="i-oc-finished"></i><h3>预售活动已结束</h3><p>玩客云预售活动已结束，感谢您的支持！</p>',
    notifi_selectcolor: '请选择颜色',
    notifi_selectdate: '请选择发货日期',
    deposit_tips_limit: '<h3>温馨提示</h3><p>每个用户只可提交2次预售订单，检测到您存在一笔超时失效预售订单，本次提交订单后请您尽快完成付款，如果再次支付超时，您将不能继续参与本次预售活动。</p>',
    deposit_tips_queue: '<i class="i-oc-queue"></i><h3>正在排队中，请不要刷新页面</h3><p>当前参与预售的小伙伴较多，正在努力为您排队，请您耐心等待，不要刷新页面喔。</p>',
    deposit_tips_yongdu: '<i class="i-oc-yongdu"></i><h3>抱歉，网络走丢了</h3><p>当前购买人数较多，正在努力为您加载，请稍候重试喔。</p>',
    deposit_tips_success: '<i class="i-oc-chenggong"></i><h3>恭喜你，已成功预定玩客云1台</h3><p>该笔订单支付有效期为15分钟，请尽快完成支付，逾期支付订单将做失效处理。</p>',
    deposit_tips_queue2: '<i class="i-oc-queue"></i><h3>正在排队中，请不要刷新页面</h3><p>当前参与预售的小伙伴较多，正在努力为您排队，请您耐心等待，不要刷新页面喔。</p>',
    product_title: '产品数量',
    product_num: '1台',

    deposit_rules: <div className="oc-buy-aside-rule"><h3>預售活動規則</h3><ol className="oc-buy-aside-rule-list"><li><strong>預售活動期間：</strong>12月13日-12月19日；</li><li><strong>預售開放時間：</strong>12月13日-19日 每天10:00-18:00；</li><li><strong>預售商品：</strong>玩客雲，顔色爲科技藍、曜石黑、愛馬仕橙；</li><li><strong>預售價格：</strong>399元全款預售；</li><li><strong>預售：</strong>是指您無需預約玩客雲，選定發貨時間後提前全款支付，以您支付成功系統告知發貨時間爲准，我們將按承諾的時間陸續爲您安排發貨；</li><li><strong>限購數量：</strong><strong>爲充分保障用戶權益，每個用戶僅限購買1台玩客雲，重複購買無效，已經成功在玩客雲官網購買過玩客雲的用戶將無法參與本次預售活動；</strong></li><li><strong>發貨時間：</strong><strong>預售商品的發貨時間，在您選定發貨時間檔內按付款的先後順序陸續安排發出，網心科技保留提前發貨的權利，</strong>爲了保證良好的用戶體驗，我們會在每月設置可發貨的時間檔位供用戶選擇；</li><li><strong>提交訂單：</strong>請正確填寫收貨信息，選取配送方式並確認所選商品顔色、價格信息，請盡快提交訂單，訂單一旦提交將不可取消；</li><li><strong>支付時效：</strong><strong>請留意您的訂單支付時效，訂單生成後即進入15分鍾支付倒計時，</strong>沒有在支付時效內成功支付的訂單，系統將視爲您自動放棄並取消訂單，您所占的發貨時間名額也將被重新釋放，已支付成功的訂單視爲本次預售下單成功；</li><li><strong>有關支付：</strong>每位用戶可以下單2次，僅可成功購買1次。您在訂單生成後實際付款前超過2次超時未支付訂單，將失去繼續參與本次預售活動的資格，用戶完成支付的時間以第三方支付或銀行提供給網心的支付流水時間爲准；</li><li><strong>預售商品支付價格：</strong>以您支付成功時的價格爲准，如預售商品發生調價，已支付訂單將不受影響；</li><li><strong>預售訂單快遞：</strong>預售訂單不支持自提，我們默認申通快遞，如選順豐快遞，需額外支付18元快遞費用；</li><li><strong>有關淘寶衆籌優惠券：</strong>本次預售活動支持淘寶衆籌期間購買的優惠券抵扣，請在優惠券有效期前完成使用，優惠券每個用戶只能使用1張，不可疊加，一經使用立即作廢，如使用優惠券後申請取消訂單，退款時以實際支付金額爲准；</li><li><strong>預售訂單退款：</strong>預售訂單在預售活動結束後至發貨日的前一天中午12:00之前，用戶可通過我的訂單自動申請售後取消預售訂單，客服在收到您的申請後，將于3-5個工作日內爲您辦理退款操作，預售訂單發貨後，退換貨流程同正常訂單一致；</li><li><strong>訂單地址不可修改：</strong>爲打擊黃牛，收貨信息將不可變更，請仔細確認您的收貨信息，付款成功後將不可更改；</li><li><strong>防範黃牛：</strong>爲保護廣大用戶的權益，打擊黃牛高價倒賣，網心將保留取消惡意訂單並給予退款的權利，一旦發現用戶存在惡意刷單、一人多單、超時支付等違規行爲，網心有權立即取消用戶的訂單並給予退款，且該用戶失去繼續參與本次預售活動的資格。網心有權依據本協議約定內容基于獨立自主判斷認定用戶是否存在惡意刷單、一人多單、超時支付等違規行爲，如用戶對網心取消訂單存有異議的，應當自其訂單被取消起24小時內與網心聯系，超過24小時的，視爲用戶不存有任何異議。</li></ol><h3>溫馨提示：</h3><ol className="oc-buy-aside-rule-list"><li>玩客雲官方購買渠道：玩客雲PC版官網、移動版官網；</li><li>爲確保您在更早的時間拿到商品，請在開售前校准您的電腦或手機時間；</li><li>由于近期玩客雲包裝LOGO進行了更新，新老包裝將隨機發貨，敬請諒解；</li><li>如有任何疑問請撥打400-109-8880還可訪問服務頁<a href="http://wpa.qq.com/msgrd?v=3&uin=212454816&site=qq&menu=yes" target="_blank">聯系QQ在線客服</a>，服務時間 09:00-21:00。</li></ol></div>,
    buy_steps: <div className="oc-buy-aside-steps"><h3>预定购买流程</h3><ol><li><h4>1. 预定购买</h4><p>预定即将开始</p></li><li className="oc-buy-aside-steps-arrow"></li><li><h4>2. 预付定金</h4><p>2017-08-10 10:10至2017-08-30: 18:00</p></li><li className="oc-buy-aside-steps-arrow"></li><li><h4>3. 支付尾款</h4><p>等待尾款时间开启</p></li><li className="oc-buy-aside-steps-arrow"></li><li><h4>4. 发货</h4><p>按定金支付顺序依次发货</p></li></ol></div>,

    verify_refresh: '刷新题目',
    verify_input: '请输入验证码',
    verify_yellow: '请您输入一次验证码，您可借助搜索引擎，我们一起防黄牛。',
    verify_error:'验证码有误，请重新填写',
    verify_empty: '请输入答案',




}



// WEBPACK FOOTER //
// ./js/src/i18n/purchase/cn.js